<template>
	<div id="ds" class="page">
		<div class="ds">
			<span v-for="item in dsList" v-on:click="event_setprice(item)">{{item.price}}元</span>
			<div class="otherprice"><label>打赏金额：￥</label><input type="text" placeholder="请输入金额" v-model="dsprice"/></div>
			<div class="btn" v-on:click="event_pay">打赏</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		dsList:[],
		dsprice:''
	}
  },
  mounted () {
	
  },
  created(){
	this.$app.pr('api/dsprice/lists').then((res) => {
		this.dsList = res.data
	})
  },
  methods:{
		event_setprice(item){
			this.dsprice = item.price
		},
		event_pay(){
			if(!/^[0-9]+?$/.test(this.dsprice) || parseInt(this.dsprice) < 1){
				this.$wx.showToast('打赏金额必须为1元以上整数')
				return false;
			}
			var that = this;
			var app = this.$app;
			var wx = this.$wx;
			app.pr('/api/dsprice/pay',{
			  type:this.$route.query.type,
			  id:this.$route.query.id,
			  user_id:this.$route.query.user_id,
			  price:this.dsprice,
			  to_user_id:this.$route.query.to_user_id
			}).then((params) => {
				that.$wx.requestPayment(params.data.paymentParams).then((res) => {
					wx.navigateTo({
						url: '/payresult?order_sn=' + params.data.order_sn,
					});
				}).catch((res) => {
					wx.showToast({
						title: '支付失败',
					});
				})
			}).catch((res) => {
				if(typeof res =='string'){
					alert(res);
				}else{
					for(var n in res){
						alert(n+':'+res[n])
					}
				}
				wx.showToast({
					title: '支付失败，请重试',
				});
			});	
		}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#ds{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.ds{
		padding:20vw;
	}
	input{
		font-size:4vw;
	}
	.ds span{
		display:inline-block;
		width:26vw;
		height:12vw;
		background-color:#d04604;
		font-size:4vw;
		color:#FFFFFF;
		line-height:12vw;
		text-align:center;
		border-radius:3vw;
		margin:2vw;
	}
	.otherprice{
		width:100%;
		padding:3vw;
		font-size:4vw;
		position:relative;
	}
	.otherprice input{
		border:0px;
		border-bottom:1px solid #EEEEEE;
		height:15vw;
		padding:0vw 3vw;
		text-align:right;
	}
	.otherprice label{
		color:#0197c5;
		position:absolute;
		display:block;
		height:15px;
		line-height:15px;
		top: 8vw;
		left: 3vw;
	}
	.btn{
		height:12vw;
		background:linear-gradient(to right, #fa8d60, #e76025);
		width:100%;
		border-radius:3vw;
		line-height:12vw;
		text-align:center;
		font-size:4vw;
		color:#FFFFFF;
	}
</style>


// WEBPACK FOOTER //
// src/components/Ds.vue